// Copyright (c) 2016 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import Claim, {getDefaultState as getClaimDefaultState} from '@deere/cps-it.warranty-model-factory/lib/claim-battery';
import ConfirmationModal, {getDefaultState as getConfirmationModalDefaultState} from '../../shared/state/confirmation-modal';
import CreateClaimModalType, {getDefaultState as getCreateClaimModalTypeDefaultState} from '../../../shared/state/create-claim-modal';
import Customer, {getDefaultState as getCustomerDefaultState} from '@deere/cps-it.warranty-model-factory/lib/customer';
import FormValidation, {getDefaultState as getDefaultFormValidationState} from './form-validation';
import KeyValuePairCollection, {getDefaultState as getDefaultKeyValueCollection} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import Product, {getDefaultState as getProductDefaultState} from '@deere/cps-it.warranty-model-factory/lib/product';
import WarrantyStatusModal, {getDefaultState as getWarrantyStatusModal} from '../../../../src/claim/shared/state/warranty-status-modal';
import t from 'tcomb';

const BatteryClaim = t.struct({
    application: KeyValuePairCollection,
    busyCounter: BusyCounter,
    claim: Claim,
    confirmationModal: ConfirmationModal,
    createClaimModal: CreateClaimModalType,
    customer: Customer,
    failureModes: KeyValuePairCollection,
    formValidation: FormValidation,
    installedBy: KeyValuePairCollection,
    isActionButtonDisabled: t.Boolean,
    isCopied: t.Boolean,
    isEditable: t.Boolean,
    isStickyHeaderVisible: t.Boolean,
    isValidClaim: t.Boolean,
    product: Product,
    temporaryObjectKey: t.String,
    warrantyStatusModal: WarrantyStatusModal
}, 'BatteryClaim');

export const getDefaultState = () =>
    new BatteryClaim({
        application: getDefaultKeyValueCollection(),
        busyCounter: getBusyCounterDefaultState(),
        claim: getClaimDefaultState(),
        confirmationModal: getConfirmationModalDefaultState(),
        createClaimModal: getCreateClaimModalTypeDefaultState(),
        customer: getCustomerDefaultState(),
        failureModes: getDefaultKeyValueCollection(),
        formValidation: getDefaultFormValidationState(),
        installedBy: getDefaultKeyValueCollection(),
        isActionButtonDisabled: false,
        isCopied: false,
        isEditable: true,
        isStickyHeaderVisible: false,
        isValidClaim: false,
        product: getProductDefaultState(),
        temporaryObjectKey: '',
        warrantyStatusModal: getWarrantyStatusModal()
    });

export default BatteryClaim;



// WEBPACK FOOTER //
// ./src/claim/battery/state/index.js